import LiveCasinoBetBehindRedux from './live_casino_bet_behind_redux';

export default LiveCasinoBetBehindRedux;
